
import React from "react";

interface SideImageProps {
  imageUrl: string;
  alt?: string;
}

const SideImage: React.FC<SideImageProps> = ({ imageUrl, alt }) => (
  <div className="hidden md:flex w-1/2 bg-gradient-to-br from-blue-700 via-blue-400 to-blue-300 items-center justify-center relative overflow-hidden">
    <img
      src={imageUrl}
      alt={alt || ""}
      className="object-cover w-full h-full brightness-90"
      style={{ minHeight: "440px" }}
      loading="lazy"
    />
    <div className="absolute inset-0 bg-black bg-opacity-25" />
    <div className="absolute bottom-0 right-0 p-8 text-white z-10 text-right">
      <h2 className="text-3xl md:text-4xl font-bold mb-3 drop-shadow-lg">مرحباً بعودتك في كنف</h2>
      <p className="text-lg mb-6 drop-shadow">سجّل دخولك لإدارة حسابك أو متابعة العقارات</p>
    </div>
  </div>
);

export default SideImage;
